import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownInCircleMulticolor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={9} fill="#168764" />
    <path
      fill="#fff"
      d="m12.707 16.707 3.364-3.364a1 1 0 0 0-1.414-1.414L13 13.586V8a1 1 0 1 0-2 0v5.586l-1.657-1.657a1 1 0 0 0-1.414 1.414l3.364 3.364a1 1 0 0 0 1.414 0"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m2 0a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowDownInCircleMulticolor;
